import { render, staticRenderFns } from "./StatusPage.vue?vue&type=template&id=01544807&scoped=true"
import script from "./StatusPage.vue?vue&type=script&lang=js"
export * from "./StatusPage.vue?vue&type=script&lang=js"
import style0 from "./StatusPage.vue?vue&type=style&index=0&id=01544807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01544807",
  null
  
)

export default component.exports